<template>
	<div class="pullDonwContainer" @click="pullIcon" :style="{height:pullHeight,width:boxWidth+'px',top:top,right:right}">
		<div class="top">
			<span v-show="flag" class="font">{{title}}</span>
			<div v-show="flag" class="icon">
				<i class="el-icon-arrow-down"></i>
			</div>
		</div>
		<img v-show="!flag" :src="url" :style="{width:imgWidth ,height:imgHeight }"/>
		<slot></slot>
	</div>
</template>

<script>
	export default {
		props:{
			width:{
				type:Number,
				default:188
			},
			height:{
				type:Number,
				default:220
			},
			title:{
				type:String,
				default:'天府新区主要经济指标'
			},
			url:{
				type:String,
				default:require('../assets/images/pullMsg.png')
			},
			top:{
				type:String,
				default:'13%'
			},
			right:{
				type:String,
				default:'30%'
			},
			imgWidth:{
				type:String,
				default:'100%'
			},
			imgHeight:{
				type:String,
				default:'100%'
			}
			
		},
		data() {
			return {
				boxWidth:this.width,
				iconName: 'arrow-down',
				pullHeight: '36px',
				flag: true,
			}
		},
		created(){
			console.log(this.title,this.url);
		},
		methods: {
			pullIcon() {
				// console.log('下拉')
				if (this.flag) {
					this.pullHeight = this.height + 'px'
					this.iconName = 'arrow-up'
					this.flag = false
				} else {
					this.pullHeight = '36px'
					this.iconName = 'arrow-down'
					this.flag = true
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.pullDonwContainer {
		// width: 188px;
		background-color: rgba($color: #141414, $alpha: 0.5);
		border-radius: 8px;
		position: fixed;
		// top: 13%;
		// right: 30%;
		z-index: 50;
		color: #fff;
		transition: all 0.3s;
		overflow: hidden;
		box-sizing: border-box;
		padding: 8px 8px;
		.top {
			display: flex;
			align-items: center;
			.icon {
				width: 24px;
				height: 24px;
				background-color: #1F262D;
				border-radius: 8px;
				display: flex;
				align-items: center;
				justify-content: center;
				position: absolute;
				top: 6px;
				right: 6px;
			}

			.font {
				font-size: 14px;
			}
		}

		image {
			width: 175px;
			height: 196px;
		}
	}
</style>
